export default "__VITE_ASSET__CadCzSLZ__"